import { render, staticRenderFns } from "./salesContractDetails.vue?vue&type=template&id=6d5f19f2&scoped=true&"
import script from "./salesContractDetails.vue?vue&type=script&lang=js&"
export * from "./salesContractDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesContractDetails.vue?vue&type=style&index=0&id=6d5f19f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f19f2",
  null
  
)

export default component.exports